import { mumsClient } from "@/lib/mumsAuth";

export const mumsApi = {
  dashboard: () => mumsClient.get("/mums/dashboard").then((r) => r.data),
  // Tubers
  listTubers: () => mumsClient.get("/mums/tubers").then((r) => r.data),
  createTuber: (p) => mumsClient.post("/mums/tubers", p).then((r) => r.data),
  updateTuber: (id, p) => mumsClient.put(`/mums/tubers/${id}`, p).then((r) => r.data),
  deleteTuber: (id) => mumsClient.delete(`/mums/tubers/${id}`).then((r) => r.data),
  sendToBloom: (id) => mumsClient.post(`/mums/tubers/${id}/send-to-blooms`).then((r) => r.data),
  // Blooms
  listBlooms: () => mumsClient.get("/mums/blooms").then((r) => r.data),
  createBloom: (p) => mumsClient.post("/mums/blooms", p).then((r) => r.data),
  updateBloom: (id, p) => mumsClient.put(`/mums/blooms/${id}`, p).then((r) => r.data),
  deleteBloom: (id) => mumsClient.delete(`/mums/blooms/${id}`).then((r) => r.data),
  // Flowers
  listFlowers: () => mumsClient.get("/mums/flowers").then((r) => r.data),
  createFlower: (p) => mumsClient.post("/mums/flowers", p).then((r) => r.data),
  updateFlower: (id, p) => mumsClient.put(`/mums/flowers/${id}`, p).then((r) => r.data),
  deleteFlower: (id) => mumsClient.delete(`/mums/flowers/${id}`).then((r) => r.data),
  // Seeds
  listSeeds: () => mumsClient.get("/mums/seeds").then((r) => r.data),
  createSeed: (p) => mumsClient.post("/mums/seeds", p).then((r) => r.data),
  updateSeed: (id, p) => mumsClient.put(`/mums/seeds/${id}`, p).then((r) => r.data),
  deleteSeed: (id) => mumsClient.delete(`/mums/seeds/${id}`).then((r) => r.data),
  // Cross-record database
  database: (q, kind) => mumsClient.get("/mums/database", { params: { q, kind } }).then((r) => r.data),
  // Gardens (builder)
  listGardens: () => mumsClient.get("/mums/gardens").then((r) => r.data),
  createGarden: (p) => mumsClient.post("/mums/gardens", p).then((r) => r.data),
  updateGarden: (id, p) => mumsClient.put(`/mums/gardens/${id}`, p).then((r) => r.data),
  deleteGarden: (id) => mumsClient.delete(`/mums/gardens/${id}`).then((r) => r.data),
  duplicateGarden: (id) => mumsClient.post(`/mums/gardens/${id}/duplicate`).then((r) => r.data),
  addBed: (gid, p) => mumsClient.post(`/mums/gardens/${gid}/beds`, p).then((r) => r.data),
  updateBed: (gid, bid, p) => mumsClient.put(`/mums/gardens/${gid}/beds/${bid}`, p).then((r) => r.data),
  deleteBed: (gid, bid) => mumsClient.delete(`/mums/gardens/${gid}/beds/${bid}`).then((r) => r.data),
  placePlant: (gid, bid, p) => mumsClient.post(`/mums/gardens/${gid}/beds/${bid}/plants`, p).then((r) => r.data),
  updatePlant: (gid, bid, pid, p) => mumsClient.put(`/mums/gardens/${gid}/beds/${bid}/plants/${pid}`, p).then((r) => r.data),
  deletePlant: (gid, bid, pid) => mumsClient.delete(`/mums/gardens/${gid}/beds/${bid}/plants/${pid}`).then((r) => r.data),
  gardenSummary: (gid) => mumsClient.get(`/mums/gardens/${gid}/summary`).then((r) => r.data),
  // Wishlist
  listWishlist: () => mumsClient.get("/mums/wishlist").then((r) => r.data),
  createWish: (p) => mumsClient.post("/mums/wishlist", p).then((r) => r.data),
  updateWish: (id, p) => mumsClient.put(`/mums/wishlist/${id}`, p).then((r) => r.data),
  deleteWish: (id) => mumsClient.delete(`/mums/wishlist/${id}`).then((r) => r.data),
  // Tasks
  listTasks: () => mumsClient.get("/mums/tasks").then((r) => r.data),
  createTask: (p) => mumsClient.post("/mums/tasks", p).then((r) => r.data),
  updateTask: (id, p) => mumsClient.put(`/mums/tasks/${id}`, p).then((r) => r.data),
  deleteTask: (id) => mumsClient.delete(`/mums/tasks/${id}`).then((r) => r.data),
  taskSuggestions: () => mumsClient.get("/mums/tasks/suggestions").then((r) => r.data),
  // Journal
  listJournal: (q) => mumsClient.get("/mums/journal", { params: q ? { q } : {} }).then((r) => r.data),
  createJournal: (p) => mumsClient.post("/mums/journal", p).then((r) => r.data),
  deleteJournal: (id) => mumsClient.delete(`/mums/journal/${id}`).then((r) => r.data),
  // Photos
  photos: () => mumsClient.get("/mums/photos").then((r) => r.data),
};

export const fileToDataURL = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(file);
});
